var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 894,
    height: 180,
    viewBox: "0 0 894 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.845 180V35.4657H210.35V0H360.509V35.4657H306.014V179.908H264.845V180Z",
    fill: "#233B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.877 180V0H419.047V69.4575H494.31V0H535.571V179.908H494.31V104.923H419.047V179.908H377.877V180Z",
    fill: "#233B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.607 180H664.134L625.17 104.463C612.856 80.5118 602.839 59.8772 598.796 49.3756H598.52C598.98 63.9304 598.98 87.8813 598.98 106.489V180H561.026V0H614.234L659.907 90.0921C668.913 107.963 674.978 122.794 679.021 131.638H679.297C678.837 116.807 678.562 98.9355 678.562 79.4985V0H716.515V180H716.607Z",
    fill: "#233B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.246 180V0H783.415V79.7748H783.875C800.968 53.0604 820.266 27.6356 840.115 0H889.555C867.5 28.1883 845.353 55.6397 823.298 83.5517L893.875 180H843.148C825.044 153.286 799.681 117.083 783.875 90.6448H783.415V180H742.246Z",
    fill: "#233B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.616 82.2621H149.232V97.6459H164.616V82.2621Z",
    fill: "#FF3B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4759 97.7379H30.8598L30.8598 82.3541H15.4759L15.4759 97.7379Z",
    fill: "#218CE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.349 31.781L148.219 20.9109L159.089 31.781L148.219 42.651L137.349 31.781ZM126.479 42.651L20.911 148.219L31.781 159.089L137.349 53.6131L126.479 42.7431V42.651Z",
    fill: "#218CE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.262 15.476V30.8598H97.6459V15.476L82.262 15.476Z",
    fill: "#218CE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6459 164.524V149.14H82.262V164.524H97.6459Z",
    fill: "#FF3B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8651 42.6982L42.7431 53.5762L53.6211 42.6982L42.7431 31.8202L31.8651 42.6982Z",
    fill: "#FF3B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180 82.2621H164.616V97.6459H180V82.2621Z",
    fill: "#233B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3838 82.2621H0V97.6459H15.3838V82.2621Z",
    fill: "#233B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6459 0H82.262V15.3838H97.6459V0Z",
    fill: "#233B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6459 164.616H82.262V180H97.6459V164.616Z",
    fill: "#233B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8372 20.9029L20.9592 31.7809L31.8372 42.659L42.7152 31.7809L31.8372 20.9029Z",
    fill: "#233B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.197 137.341L137.319 148.219L148.197 159.097L159.075 148.219L148.197 137.341Z",
    fill: "#233B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.349 126.387L108.608 97.738H149.232V82.2621H97.738V30.8598H82.262V71.392L53.6131 42.7431L42.7431 53.6131L71.392 82.2621H30.8598V97.738H82.262V149.232H97.738V108.608L126.387 137.349L137.349 126.387Z",
    fill: "#233B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.227 137.338L137.349 126.46L126.471 137.338L137.349 148.216L148.227 137.338Z",
    fill: "#218CE7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_244"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 893.966,
    height: 180,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.78de14a060bfc93ab073eee261a992d5.svg";
export { ForwardRef as ReactComponent };